import React, { useContext, useEffect, useMemo } from "react"
import { Grid } from "@material-ui/core"
import { useForm, FormProvider} from 'react-hook-form'
import { OrangeButton } from "../Core/Buttons/OrangeButton"
import { QuoteContextStore } from '../../context/QuoteContext/QuoteContext';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import AircraftDetailsSection from "./AircraftSections/AircraftDetailsSection"
import { FlowBackButton } from '../Core/Buttons/FlowBackButton';
import {LoadingContextStore} from "../../context/LoadingContext/LoadingContext";
import { AlertContextStore } from '../../context/AlertContext/AlertContext';
import { SessionContextStore } from "../../context/SessionContext/SessionContext";
import { Redirect, useParams } from 'react-router-dom';


export const AircraftSchema = yup
.object()
  .shape({
    make: yup.string("Required").nullable().required("Required"),
    model: yup.string("Required").nullable().required("Required"),
    year: yup.string("Required").nullable().typeError('Required').required("Required").test("year", "Should be a valid year", (year) => year >= 1944 && year <= new Date().getFullYear()),
    max_value: yup.number("Required"),
    min_value: yup.number("Required"),
    allow_hull: yup.boolean().nullable(),
    value: yup.string("Required")
    .when(['allow_hull'], (allow_hull, schema) => {
        return allow_hull ? schema.typeError('Required').required("Required").test("checkForZeros", "Required", (value) => value !== "0") : schema;
    }),
    total_seats: yup.number("Required").typeError('Required').required("Required").min(1, "Required").max(8),
    make_model_not_found: yup.boolean(),
    is_hangared: yup.string().required("Required")
})
.required();

export const AircraftStep = () => {
    const { aircrafts, finishAircraft } = useContext(QuoteContextStore);
    const { awaitWithLoading } = useContext(LoadingContextStore);
    const form = useForm({mode: 'onBlur' ,defaultValues: { ...aircrafts[Object.keys(aircrafts)[0]] }, resolver: yupResolver(AircraftSchema)});
    const {quoteId} = useParams()
    
    useEffect(() => {
        form.reset({...aircrafts[Object.keys(aircrafts)[0]]});
    }, [aircrafts[Object.keys(aircrafts)[0]]]);

    const onSubmit = async (data) => {
        data.aircraft_id = Number(Object.keys(aircrafts)[0])
        if(aircrafts[Object.keys(aircrafts)[0]].n_number){
            data.n_number = aircrafts[Object.keys(aircrafts)[0]].n_number
        }
        
        const submittedData = {...data, value: data.value.replace(/\D/g, '') }
        await awaitWithLoading(finishAircraft({...submittedData, quote_id: quoteId}));
    }

    return (
        <React.Fragment>
            <form onSubmit={form.handleSubmit(onSubmit)} className="margin-top-medium margin-bottom-basic">
                <FormProvider {...form}>
                    <AircraftDetailsSection />
                    <Grid className="margin-top-basic" container item justifyContent="space-between" lg={9}>
                        <Grid item>
                            <FlowBackButton />
                            <OrangeButton type="submit">Save & Continue</OrangeButton>
                        </Grid>
                    </Grid>
                    <input hidden {...form.register('max_value')}/>
                    <input hidden {...form.register('min_value')}/>
                </FormProvider>
            </form>
        </React.Fragment>
    )
}

export default AircraftStep;